import { Component, ViewChild, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../../shared/shared.module';
import { TeacherSidenavbarComponent } from '../teacher-navbar/teacher-sidenavbar/teacher-sidenavbar.component';
import { MatSidenav } from '@angular/material/sidenav';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
	selector: 'app-teacher-dashboard',
	standalone: true,
	imports: [SharedModule, RouterModule, TeacherSidenavbarComponent],
	templateUrl: './teacher-dashboard.component.html',
	styleUrl: './teacher-dashboard.component.scss',
})
export class TeacherDashboardComponent implements OnInit {
	@ViewChild(MatSidenav) sidenav!: MatSidenav;
	collapsed: boolean = false;
	isMobile: boolean = false;

	constructor(private observer: BreakpointObserver) { }

	ngOnInit() {
		this.observer.observe(['(max-width: 768px)']).subscribe((screen) => {
			if (screen.matches) {
				this.isMobile = true;
				this.collapsed = false; // Always expanded when open on mobile
			} else {
				this.isMobile = false;
				this.collapsed = false;
			}
		});
	}

	toggleSidenav() {
		if (this.isMobile) {
			this.sidenav.toggle();
		} else {
			this.collapsed = !this.collapsed;
		}
	}

	closeSidenav() {
		if (this.isMobile) {
			this.sidenav.close();
		}
	}
}

